// @flow

import { Component } from '../jsti/core';
import Notifications from '../constants/Notifications';
import Template from '../classes/Template';
import FilterVersions from '../constants/FilterVersions';
import FilterGroupsConstant from '../constants/FilterGroups';

export default class FilterGroups extends Component {
  dynamicGroups: Array<HTMLElement>;
  priceRange: ?HTMLElement;
  checkboxTemplate: HTMLElement;
  version: string;

  /**
   * Initialize the component
   */
  bind(el: HTMLElement): void {
    super.bind(el);
    this.dynamicGroups = this.getDynamicItems();
    this.version = el.dataset.version;
    this.priceRange = this.el.getElementByRef('price-range');
    this.addListener(Notifications.FILTERED, this.handleFiltered.bind(this));
    this.checkboxTemplate = Template.getContent(el.getElementByRef('checkbox-group-template'));
  };

  /**
   * Executes when the user has filtered
   */
  handleFiltered(data: Object): void {
    const groupsData: Array<Object> = data.data.filterGroups;
    groupsData.forEach((groupData: Object) => {
      this.renderGroup(groupData);
    });
    this.removeDynamicItems();
    this.dynamicGroups = this.getDynamicItems();
    if (!data.group) {
      this.notify(Notifications.CLEAR_VIEW_PANEL);
    }
  }

  /**
   * Render a new group
   */
  renderGroup(data: Object): void {
    if (data.type !== FilterGroupsConstant.CHECKBOX) return;

    const CheckboxBuilder: Class = this.version === FilterVersions.MOBILE
      ? require('../classes/filter/MobileCheckboxGroup').default
      : require('../classes/filter/DesktopCheckboxGroup').default;

    const template = this.checkboxTemplate.cloneNode(true);

    const group = new CheckboxBuilder(template, data).build();

    if (this.priceRange && this.priceRange.parentNode) {
      this.priceRange.parentNode.insertBefore(group, this.priceRange);
    } else {
      this.el.appendChild(group);
    }
  }

  /**
   * Get all dynamic items
   */
  getDynamicItems(): Array<HTMLElement> {
    return Array.from(this.el.querySelectorAll('[data-dynamic]'));
  }

  /**
   * Remove all dynamic items from the DOM
   */
  removeDynamicItems(): void {
    this.dynamicGroups.forEach((group: HTMLElement) => {
      group.remove();
    });
  }
}
